export default __webpack_public_path__ + "static/media/web.59a1360d.png";